import { LogOut } from 'lucide-react';

/**
 * Where an LMS-launched session ends. Learners from an LMS have no Skillzen
 * login, and the login page cannot be shown inside the LMS frame anyway.
 */
export default function LtiSignedOut() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4 py-8">
      <div className="text-center max-w-md space-y-4">
        <LogOut className="mx-auto h-12 w-12 text-primary-600" />
        <div>
          <p className="text-lg font-semibold text-gray-900">You've signed out of Skillzen</p>
          <p className="text-gray-500 mt-2">
            To continue learning, open the Skillzen activity again from your course in your
            learning platform (for example, Moodle).
          </p>
        </div>
      </div>
    </div>
  );
}
